import { render } from "./CandlesChartStudies.vue?vue&type=template&id=1d26b906"
import script from "./CandlesChartStudies.vue?vue&type=script&lang=js"
export * from "./CandlesChartStudies.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__